var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { cursor: "pointer" },
        attrs: { "data-toggle": "modal", "data-target": "#" + _vm.id }
      },
      [_vm._t("default", [_c("span", { staticClass: "fa fa-list-alt" })])],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: _vm.id, tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog modal-lg" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "div",
              {
                staticClass: "modal-header",
                staticStyle: { "border-top": "none" }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "h4",
                  {
                    staticClass: "modal-title",
                    staticStyle: { margin: "0", color: "rgb(51, 51, 51)" }
                  },
                  [_vm._v(_vm._s(_vm.value.licenseeName))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [_c("Licence", { attrs: { licence: _vm.value } })],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: { type: "button", "data-dismiss": "modal" }
      },
      [_c("span", [_vm._v("×")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-620f1060", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620f1060","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanyModal.vue
// module id = null
// module chunks = 